// Lib
import { EditorState, Modifier, SelectionState } from 'draft-js';

// Utils
import forceFocus from './forceFocus';

// Constants
import { EditorChangeType } from '../draftjsConstants';

const removeAllInlineStyle = (editorState) => {
    const currentContent = editorState.getCurrentContent();

    const prevSelectionState = editorState.getSelection();

    const text = editorState.getCurrentContent().getPlainText();
    const selection = editorState.getSelection();
    const startKey = selection.getStartKey();

    const allSelection = new SelectionState({
        anchorKey: startKey,
        anchorOffset: 0,
        focusKey: startKey,
        focusOffset: text.length,
    });

    const newContentState = Modifier.replaceText(currentContent, allSelection, text, null, null);
    const newEditorState = EditorState.push(editorState, newContentState, EditorChangeType.CHANGE_INLINE_STYLE);

    return forceFocus(newEditorState, prevSelectionState);
};

export default removeAllInlineStyle;
